<template>
  <transition name="el-fade-in"><router-view /></transition>
</template>

<script>
import router from "./router";

export default {
  mounted() {
    window.addEventListener("unload", this.saveState());
    let token = localStorage.getItem("token");
    if (token == null || token == "") {
      router.push("/login");
    }
  },
  methods: {
    saveState() {
      // console.log("页面刷新");
      let token = localStorage.getItem("token");
      if (token == null || token == "") {
        router.push("/login");
      }
      // this.$store.commit("MENUS", sessionStorage.getItem("menus"));
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

// 两侧留白删除
body,
html {
  margin: 0px;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
// 全局滚动条美化
::-webkit-scrollbar {
  width: 6px;
  height: 8px;
  background-color: #ebeef5;
}
::-webkit-scrollbar-thumb {
  // border-radius:2px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #ccc;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  background: rgba(255, 255, 255, 1);
}
</style>
